import { connect } from 'react-redux';
import { doLogout } from '../../store/user/actions';
import Users from './contratoEscrow';

const mapDispatchToProps = {
  doLogout,
};

export default connect(null, mapDispatchToProps)(Users);
